import React from "react";
import Button from "@mui/material/Button";
import { useHistory, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import InstaColors, {
  EditButton,
  fontFamily,
  screenHeaderStyle,
  useSharedValue,
} from "../Constants/constants";

import { BASE_URL } from "../../App_Settings/app_settings";
import { Input } from "reactstrap";
import backArrowIcon from "../../assets/new icons/extraction review/back arrow.svg";
import saveIcon from "../../assets/new icons/file import/save.svg";
import dragIcon from "../../assets/new icons/file import/drag.svg";
import DraggableModal from "./dragable_model";
import { getUserIdFromLocalStorage } from "../../API_Endpoints/APIEndpoints";
import { updateFileData } from "../../services/fileDataService";
import SecureDocumentViewer from "./SecureDocumentViewer";

export default function DispalyAndEditFile() {
  const location = useLocation();
  let someValue = location.state?.someValue;
  const fromPage = location.state?.fromPage;
  const returnPath = location.state?.returnPath || "/workloadFileImport"; // Default fallback

  const [editingData, setEditingData] = React.useState(null);
  const [userName, setUserName] = useState("");
  const [isEditPopupOpen, setIsEditPopupOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const { isMenuOpen, DataExtractProcess } = useSharedValue();
  const [userId, setuserId] = useState(null);

  const [isSuccessPopup, setIsSuccessPopup] = useState(false);

  const [rows, setRows] = useState([]);

  const maxPages = Math.ceil(rows.length / 6);
  const [fileName, setFileName] = React.useState("");
  const [businessUnits, setBusinessUnits] = React.useState([]);
  const [id, setId] = React.useState("");
  const [businessUnit, setBusinessUnit] = React.useState("Select a Client");
  const [selectPackOption, setSelectPackOption] = React.useState("Select Upload Type");
  const [numberOfDataRows, setDataRows] = React.useState("");
  const [numberOfTiers, setTiers] = React.useState("");
  // const classes = useStyles();
  const [investment, setInvestment] = React.useState("");
  const [uploadedDate, setUploadedDate] = React.useState("");
  const [processIdentifier, setProcessIdentifier] = React.useState("AI Extrcator - I");
  const [withholdingStatementInfo, setWithholdingStatementInfo] = useState(
    "There are number of rows and number of columns in the table and I need these columns, column names are example 1, example 2 and first row starts from enter value and last row ends with enter value"
  );
  const [units, setUnits] = React.useState(["Select"]);
  const process = ["AZURE-AI"];
  const history = useHistory();

  // Check if coming from bulk form import
  const isFromBulkFormImport =
    fromPage === "bulkFormImport" ||
    window.location.pathname === "/bulkFormImport" ||
    document.referrer?.includes("bulkFormImport");

  // Define different pack options based on source
  const allPackOptions = [
    "Withholding Statement",
    "W-9",
    "W-8BEN",
    "W-8BEN-E",
    "W-8IMY",
    "W-8ECI",
    "W-8EXP",
    "8233",
    "Self-Cert Individual",
    "Self-Cert Entity",
    "Pack With Forms",
    "Deloitte Excel",
  ];

  // Single form options only (exclude Withholding Statement and Pack With FORMS)
  const singleFormPackOptions = [
    "W-9",
    "W-8BEN",
    "W-8BEN-E",
    "W-8IMY",
    "W-8ECI",
    "W-8EXP",
    "8233",
    "Self-Cert Individual",
    "Self-Cert Entity",
  ];

  // Use appropriate options based on source
  const packOptions = isFromBulkFormImport ? singleFormPackOptions : allPackOptions;

  // Function to get upload type number based on selected option and source
  const getUploadTypeNumber = (selectedOption) => {
    if (isFromBulkFormImport) {
      // For bulk form import, map form types to values 2-10
      const formTypeMap = {
        "W-9": 2,
        "W-8BEN": 3,
        "W-8BEN-E": 4,
        "W-8IMY": 5,
        "W-8ECI": 6,
        "W-8EXP": 7,
        8233: 8,
        "Self-Cert Individual": 9,
        "Self-Cert Entity": 10,
      };
      return formTypeMap[selectedOption] || null;
    } else {
      // Special case for Deloitte Excel
      if (selectedOption === "Deloitte Excel") {
        return 13;
      }
      // For workload file import, use index + 1 (values 1-11)
      return packOptions.indexOf(selectedOption) + 1;
    }
  };

  // Function to get display option from upload type number
  const getDisplayOptionFromUploadType = (uploadType) => {
    if (isFromBulkFormImport) {
      // For bulk form import, reverse map from values 2-10 to form types
      const reverseFormTypeMap = {
        2: "W-9",
        3: "W-8BEN",
        4: "W-8BEN-E",
        5: "W-8IMY",
        6: "W-8ECI",
        7: "W-8EXP",
        8: "8233",
        9: "Self-Cert Individual",
        10: "Self-Cert Entity",
      };
      return reverseFormTypeMap[uploadType] || "Select Upload Type";
    } else {
      // Special case for Deloitte Excel
      if (uploadType === 13) {
        return "Deloitte Excel";
      }
      // For workload file import, use index - 1
      if (uploadType === 11) return packOptions[0];
      return uploadType
        ? packOptions[uploadType - 1] || "Select Upload Type"
        : "Select Upload Type";
    }
  };
  const investmentList = ["Select", "No", "Yes"];
  const [isChecked, setIsChecked] = React.useState(false);
  const [currentPage, setCurrentPage] = useState(1); // Current page number

  React.useEffect(() => {
    const userDataJSON = localStorage.getItem("token");
    const userData = JSON.parse(userDataJSON);

    fetch(`${BASE_URL}/FileData/GetAllFiles/${userData.userId}`, {
      headers: { Authorization: `Bearer ${getUserIdFromLocalStorage().token}` },
    })
      .then((response) => response.json())
      .then((data) => {
        setRows(
          data
            .reverse()
            .filter((row) => row.userId === userData.userId && row.isProcessed === false)
        );
        if (someValue != null) {
          setSelectedRow(someValue);
        }
      })
      .catch((error) => console.error("Error fetching data:", error));
  }, []);
  React.useEffect(() => {
    // Fetching data from the backend server
    const userDataJSON = localStorage.getItem("token");

    if (userDataJSON) {
      const userData = JSON.parse(userDataJSON);
      // Fetching data from the backend server
      (async () => {
        try {
          const { getBusinessUnits } = await import("../../Utility/utility");
          const data = await getBusinessUnits(userData.organizationId);
          // Add default option at the beginning
          const businessUnitNames = data
            .filter((row) => row.isDeleted === false)
            .map((item) => item.name);
          setUnits(businessUnitNames);
          // Here, you can transform the fetched data to match the format of your 'data' array.
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      })();
    }
  }, []);

  const closeEditPopWindow = () => {
    handleBackButton();
    setIsEditPopupOpen(false);
  };

  React.useEffect(() => {
    if (someValue) {
      setFileName(someValue.fileName);
      setId(someValue.fileImportId);
      setProcessIdentifier(someValue.processIdentifier);
      // Only set businessUnit if it has a valid value, otherwise keep default
      setBusinessUnit(someValue.businessUnit || "Select a Client");
      setUploadedDate(someValue.uploadedDate);
      setDataRows(someValue.numberOfRows);
      // Convert numeric uploadType back to corresponding string value using the new function
      setSelectPackOption(getDisplayOptionFromUploadType(someValue.uploadType));
      setTiers(someValue.numberofTiers);
      setIsEditPopupOpen(true);
      setInvestment(someValue.isInvestment === true ? investmentList[2] : investmentList[1]);
      setIsChecked(someValue.isWithholding == true ? false : true);
    }
  }, [someValue]);

  React.useEffect(() => {
    if (!process.includes(processIdentifier)) {
      setProcessIdentifier(process[0]);
    }
  }, [processIdentifier, process]);

  // Removed the useEffect that was auto-selecting business unit
  // Now user must manually select a business unit

  const updateData = () => {
    if (businessUnit === "Select a Client" || businessUnit === null || businessUnit === "") {
      alert("Please select a Client");
      return false;
    } else if (
      selectPackOption === "Select Upload Type" ||
      selectPackOption === null ||
      selectPackOption === ""
    ) {
      alert("Please select an Upload Type");
      return false;
    } else if (
      businessUnit === "Select a Client" ||
      businessUnit === null ||
      businessUnit === "" ||
      selectPackOption === "Select Upload Type" ||
      selectPackOption === null ||
      selectPackOption === ""
    ) {
      alert("Please select both required fields before saving");
      return;
    } else {
      // Use the new function to get upload type number based on source page
      let uploadTypeNumber = getUploadTypeNumber(selectPackOption);
      if (isNaN(uploadTypeNumber) || uploadTypeNumber < 1) {
        uploadTypeNumber = null;
      }
      const updatedRowData = {
        fileImportId: someValue.fileImportId,
        userId: userId,
        fileName: someValue.fileName,
        filePath: selectPackOption,
        uploadType: uploadTypeNumber,
        prcoessIdentifier: processIdentifier,
        isProcessed: false,
        businessUnit: businessUnit === "Select a Client" ? "" : businessUnit,
        uploadedBy: userName,
        uploadedDate: someValue.uploadedDate,
        reviewedBy: "",
        reviewedDate: null,
        approvedBy: "",
        approvedDate: null,
        emailedTo: "",
        emailedDate: null,
        isInvestment: investment == "Yes" ? true : false,
        isWithholding: isChecked === true ? false : true,
        numberOfRows: numberOfDataRows === "" ? 0 : parseInt(numberOfDataRows),
        numberOfTiers: numberOfTiers === "" ? 0 : parseInt(numberOfTiers),
        status: null,
        totalPages: someValue.totalPages,
        totalForms: someValue.totalForms,
        accuracyPercentage: null,
        rejectionReason: "",
        notes: "",
      };

      updateFileData(updatedRowData)
        .then(() => {
          handleBackButton(false); // false for Save button
          closeEditPopWindow();
        })
        .catch((error) => {
          console.error("Error updating file data:", error);
          alert("Failed to save changes. Please try again.");
        });
    }
  };

  // Save data for Extract Data button - returns promise
  const saveDataAndExtract = () => {
    return new Promise((resolve) => {
      if (businessUnit === "Select a Client" || businessUnit === null || businessUnit === "") {
        alert("Please select a Client");
        resolve(false);
        return;
      }

      if (
        selectPackOption === "Select Upload Type" ||
        selectPackOption === null ||
        selectPackOption === ""
      ) {
        alert("Please select an Upload Type");
        resolve(false);
        return;
      }

      // Use the new function to get upload type number based on source page
      let uploadTypeNumber = getUploadTypeNumber(selectPackOption);
      if (isNaN(uploadTypeNumber) || uploadTypeNumber < 1) {
        uploadTypeNumber = null;
      }

      const updatedRowData = {
        fileImportId: someValue.fileImportId,
        userId: userId,
        fileName: someValue.fileName,
        filePath: selectPackOption,
        uploadType: uploadTypeNumber,
        prcoessIdentifier: processIdentifier,
        isProcessed: false,
        businessUnit: businessUnit === "Select a Client" ? "" : businessUnit,
        uploadedBy: userName,
        uploadedDate: someValue.uploadedDate,
        reviewedBy: "",
        reviewedDate: null,
        approvedBy: "",
        approvedDate: null,
        emailedTo: "",
        emailedDate: null,
        isInvestment: investment == "Yes" ? true : false,
        isWithholding: isChecked === true ? false : true,
        numberOfRows: numberOfDataRows === "" ? 0 : parseInt(numberOfDataRows),
        numberOfTiers: numberOfTiers === "" ? 0 : parseInt(numberOfTiers),
        status: null,
        accuracyPercentage: null,
        rejectionReason: "",
        totalPages: someValue.totalPages,
        totalForms: someValue.totalForms,
        notes: "",
      };

      updateFileData(updatedRowData)
        .then(() => {
          closeEditPopWindow();
          resolve(true);
        })
        .catch((error) => {
          console.error("Error updating file data:", error);
          resolve(false);
        });
    });
  };

  useEffect(() => {
    const userDataJSON = localStorage.getItem("token");

    if (userDataJSON) {
      const userData = JSON.parse(userDataJSON);

      setUserName(userData.firstName + " " + userData.lastName);
      setuserId(userData.userId);
      // Make sure 'email' property exists in your data.
    }
  }, []);
  const handleBackButton = (isExtractDataClicked = false) => {
    // Navigate back to the page that sent the user here
    history.push(returnPath, {
      isExtractDataClicked: isExtractDataClicked,
      fileImportId: someValue?.fileImportId,
    });
  };

  return (
    <div className={screenHeaderStyle(isMenuOpen)}>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          margin: 20,
        }}
      >
        <span
          onClick={(e) => {
            e.preventDefault();
            handleBackButton();
          }}
          style={{
            color: "#6a6a6b",
            cursor: "pointer",
            fontFamily: fontFamily,
            display: "flex",
            alignItems: "center",
            gap: 6,
          }}
        >
          <img src={backArrowIcon} alt="Back" /> Back
        </span>
        <span
          onClick={() => {
            setIsEditPopupOpen(true);
          }}
          style={{
            color: InstaColors.primary,
            marginLeft: "auto",
            cursor: "pointer",
            fontFamily: fontFamily,
          }}
        >
          <EditButton
            onClick={() => {
              setIsEditPopupOpen(true);
            }}
          />
        </span>
      </div>
      <div
        style={{
          width: "calc(100% - 40px)",
          background: "#ffffff",
          overflow: "hidden",
          borderRadius: 6,
          margin: 20,
          marginTop: 0,
          marginBottom: 30,
          marginLeft: 20,
          marginRight: 20,
          display: "flex",
          flexDirection: "column",
          height: "calc(100vh)",
        }}
      >
        <div
          style={{ height: "100%", border: "none", overflow: "hidden", backgroundColor: "#ffffff" }}
        >
          <SecureDocumentViewer
            organizationId={someValue?.organizationId}
            userId={someValue?.userID}
            fileImportId={someValue?.fileImportId}
            fileName={someValue?.fileName}
            style={{ height: "100%", width: "100%" }}
            fileType="uploadfiles"
          />
        </div>
        <DraggableModal open={isEditPopupOpen} onClose={() => setIsEditPopupOpen(false)}>
          <div
            style={{
              top: "50px",
              border: "1px solid #c6c6c6",
              outline: "none",
              position: "absolute",
              right: "20px",
              width: "290px",
              padding: "15px",
              backgroundColor: "white",
              borderRadius: "5px",
            }}
          >
            <div
              style={{
                alignItems: "start",
                display: "flex",
                flexDirection: "column",
                border: "none",
              }}
            >
              <div style={{ display: "flex", flexDirection: "row" }}>
                <span
                  style={{
                    color: "#6a6a6b",
                    fontWeight: 500,
                    marginRight: 20,
                    fontFamily: fontFamily,
                  }}
                >
                  Extraction Review
                </span>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    gap: "16px",
                    alignItems: "center",
                  }}
                >
                  <img
                    src={backArrowIcon}
                    alt="Go Back"
                    title="Go Back"
                    onClick={(e) => {
                      e.preventDefault();
                      handleBackButton();
                    }}
                  />
                  <img
                    src={saveIcon}
                    alt="Save Changes"
                    title="Save Changes"
                    onClick={updateData}
                  />
                  <img src={dragIcon} alt="Move" title="Move" />
                </div>
              </div>

              <div style={{ marginBottom: "10px", marginTop: "10px" }}>
                <span
                  style={{
                    fontSize: 12,
                    fontWeight: 500,
                    fontFamily: fontFamily,
                    color: "#6a6a6b",
                  }}
                >
                  File Name
                </span>
                <Input
                  value={someValue.fileName}
                  disabled
                  onChange={(e) => setFileName(e.target.value)}
                  variant="outlined"
                  style={{
                    backgroundColor: "#E9F5FE",
                    color: "#6a6a6b",
                    border: "0px",
                    fontSize: 12,
                    border: "none",
                    borderRadius: "2.7px",
                    height: 34,
                    width: 250,
                    fontFamily: fontFamily,
                    fontWeight: 400,
                  }}
                />
              </div>
              <div>
                <span
                  style={{
                    color: "#6a6a6b",
                    fontSize: 12,
                    fontWeight: 500,
                    fontFamily: fontFamily,
                  }}
                >
                  Client <span style={{ color: "red" }}>*</span>
                </span>
                <select
                  value={businessUnit}
                  onChange={(event) => {
                    setBusinessUnit(event.target.value);
                  }}
                  style={{
                    height: 40,
                    width: 250,
                    borderRadius: "2.7px",
                    border: "none",
                    alignItems: "center",
                    outline: "none",
                    fontFamily: fontFamily,
                    fontWeight: 400,
                    fontSize: 12,
                    color: "#6a6a6b",
                    backgroundColor: "#E9F5FE",
                    appearance: "none",
                    WebkitAppearance: "none",
                    MozAppearance: "none",
                    paddingLeft: 10,
                  }}
                >
                  <option value="">Select a Client</option>
                  {units.map((item, index) => (
                    <option value={item}>{item}</option>
                  ))}
                </select>
              </div>
              {/* Pack Dropdown */}
              <div>
                <span
                  style={{
                    color: "#6a6a6b",
                    fontSize: 12,
                    fontWeight: 500,
                    fontFamily: fontFamily,
                  }}
                >
                  Upload Type <span style={{ color: "red" }}>*</span>
                </span>
                <select
                  value={selectPackOption}
                  onChange={(event) => {
                    setSelectPackOption(event.target.value);
                  }}
                  style={{
                    height: 40,
                    width: 250,
                    borderRadius: "2.7px",
                    border: "none",
                    alignItems: "center",
                    outline: "none",
                    fontFamily: fontFamily,
                    fontWeight: 400,
                    fontSize: 12,
                    color: "#6a6a6b",
                    backgroundColor: "#E9F5FE",
                    appearance: "none",
                    WebkitAppearance: "none",
                    MozAppearance: "none",
                    paddingLeft: 10,
                  }}
                >
                  <option value="">Select Upload Type</option>
                  {packOptions.map((item, index) => (
                    <option value={item}>{item}</option>
                  ))}
                </select>
              </div>

              <div>
                <span
                  style={{
                    color: "#6a6a6b",
                    fontSize: 12,
                    fontWeight: 500,
                    fontFamily: fontFamily,
                  }}
                >
                  $ Investment
                </span>
                <select
                  value={investment}
                  onChange={(e) => {
                    console.log(e);
                    setInvestment(e.target.value);
                  }}
                  style={{
                    height: 40,
                    width: 250,
                    borderRadius: "2.7px",
                    border: "none",
                    alignItems: "center",
                    outline: "none",
                    fontFamily: fontFamily,
                    fontWeight: 400,
                    fontSize: 12,
                    color: "#6a6a6b",
                    backgroundColor: "#E9F5FE",
                    appearance: "none",
                    WebkitAppearance: "none",
                    MozAppearance: "none",
                    paddingLeft: 10,
                  }}
                >
                  {investmentList.map((item, index) => (
                    <option value={item}>{item}</option>
                  ))}
                </select>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: "20px",
                  width: "100%",
                }}
              >
                <Button
                  onClick={async () => {
                    // First save the data
                    const saveResult = await saveDataAndExtract();
                    if (saveResult) {
                      // Navigate back with instruction to select row and run process
                      history.push(returnPath, {
                        selectRowAndRunProcess: true,
                        fileImportId: someValue.fileImportId,
                        fromExtractData: true,
                        isExtractDataClicked: true,
                      });
                    }
                  }}
                  className="review-btn-filled"
                  style={{
                    width: 150,
                    minWidth: "150px",
                  }}
                  variant="contained"
                >
                  Extract Data
                </Button>
              </div>
            </div>
          </div>
        </DraggableModal>
      </div>
    </div>
  );
}
